export const nStyles = (...styles: string[]) => styles.join(" ");